import React, { useEffect, useState } from 'react';
import cs from 'classnames';
import styles from './index.module.scss';
import { Icon } from '@shakkerai/components';
import { usePartialState } from '../../../store/state';

export const LABEL_LEVEL = {
  l1: 1,
  l2: 2,
};

const LoraLabel = React.memo(({ data, label2Code, chooseLabel, filters: { category, sortType } }) => {
  const topKeyword = usePartialState('keyword');
  const [whichLevel, setWhichLevel] = useState(2);
  useEffect(() => {
    setWhichLevel(topKeyword.value ? LABEL_LEVEL.l1 : LABEL_LEVEL.l2);
  }, [topKeyword]);
  const jump = (e) => {
    if (sortType === '2') return;
    chooseLabel({ ...data, whichLevel });
    e.stopPropagation();
  };
  return (
    <div
      className={cs('flex rounded-md mr-2 px-3 py-[2px] items-center justify-center bg-[#F3F5F7] cursor-pointer', {
        [styles.labelContainer]: category === '0' && !topKeyword.value,
        [styles.label2Container]: category !== '0' || topKeyword.value,
        [styles.disabled]: sortType === '2',
        [styles.checked]: (whichLevel === LABEL_LEVEL.l1 ? data?.code : data?.includedTags) === label2Code,
      })}
      onClick={jump}
    >
      <p className="h-5 relative bottom-[-1px]" style={{ fontSize: '13px' }}>
        {whichLevel === LABEL_LEVEL.l1 ? data.tagLabel : data.alias}
      </p>
      {category === '0' && !topKeyword.value ? (
        <Icon className={cs('shk-kuangjia-xiala rotate-[-90deg]', styles.icon)} />
      ) : null}
    </div>
  );
});
export default LoraLabel;
